import { Heading } from "./heading"
import { Text } from "./text"
import { Link } from "./link"
import { Center } from "./Center"
import { Badge } from "./badge"
import { formElements } from "./formElements"
import { Message } from "./message"

export const components = {
  Heading,
  Text,
  Link,
  Center,
  Badge,
  ...formElements,
  Message,
}
